/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { AuthService, MerchantService, EventQueueService } from "../../../services";
import { AppEventType } from "../../../app-event-type.enum";
import { Router } from "@angular/router";
import { Merchant, AppEvent } from "../../../models";
import { Subscription } from "rxjs";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["header.component.scss"]
})
export class HeaderComponent implements OnInit, OnDestroy {
  constructor(
    private merchantService: MerchantService,
    private authService: AuthService,
    private eventQueueService: EventQueueService,
    private router: Router,
    private eventQueue: EventQueueService
  ) {}

  faBars = faBars;
  merchantInfo!: Merchant;
  username = "";
  subscription!: Subscription;
  routeMerchantId!: number;
  @Input("menuCollapsed") menuCollapsed!: boolean;
  @Input("isUserLogged") isUserLogged!: boolean;
  @Output() menuCollapseEvent = new EventEmitter<boolean>();

  ngOnInit(): void {
    this.username = this.authService.getUserName();
    this.eventQueueService.on(AppEventType.Login).subscribe(() => this.handleLogin());
    this.subscription = this.merchantService.merchantChange.subscribe((merchant) => (this.merchantInfo = merchant));
  }

  ngOnDestroy() {
    // prevent memory leak when component destroyed
    this.subscription.unsubscribe();
  }

  hasRoute(route: string): boolean | null {
    if (this.router.url.match(route)) {
      const routeArray = this.router.url.split("/");
      return this.merchantInfo.id === Number.parseInt(routeArray[2]);
    }
    return false;
  }

  /**
   * Helper to test if merchant info object is empty
   *
   * @returns {boolean}
   */
  isMerchantInfoEmpty(): boolean {
    return 0 === Object.keys(this.merchantInfo).length;
  }

  getMerchantDeactivatedDate(): Date {
    return this.merchantInfo.deactivatedDate;
  }

  logOut(): void {
    // TODO: Implement Actual Logout
    this.authService.logout();
    this.isUserLogged = false;
    this.username = "";
    this.menuCollapseEvent.emit(true);
    this.router.navigate(["/user/login"]);
    if (!this.menuCollapsed) {
      this.eventQueue.dispatch(new AppEvent(AppEventType.menuCollapse));
    }
  }

  showMenu(): void {
    this.menuCollapseEvent.emit(false);
    this.eventQueue.dispatch(new AppEvent(AppEventType.menuCollapse));
  }

  private handleLogin(): void {
    this.username = this.authService.getUserName();
    this.isUserLogged = this.authService.isUserLogged();
    this.showMenu();
  }

  private checkUser(): void {
    const userLogged = this.authService.checkUser();
    if (userLogged) {
      this.handleLogin();
    }
  }
}
